import React from 'react';

const Tsogchen = () => {
    return (
        <h1>Цогчэн</h1>
        // <h1>Дарьганга</h1>
    )
}
export default Tsogchen;